import React from 'react';
import { MESSAGE_DIRECTION } from '@whatsper/texterchat-common';
import { getFileUrl } from '../../../../store/FilesStore';
import VoiceNotePlayer from '../../../Base/VoiceNotePlayer';
import s from './AudioMessage.module.scss';
const AudioMessage = ({ media, direction }) => {
    const url = media.fileId ? getFileUrl(media.fileId) : media.url;
    if (!url) {
        console.error('Message have no file ID or URL');
        return null;
    }
    return (React.createElement(VoiceNotePlayer, { className: s.audioMessage, src: url, seed: media.fileId || url, variant: direction === MESSAGE_DIRECTION.IN ? 'incoming' : 'outgoing' }));
};
export default AudioMessage;
